import React, { useState, useEffect } from 'react'
import Ourservice from '../Common/our_service'
import Contactus from '../Common/Contactus'
import psicon from '../../assets/images/psicon.png'
import aiicon from '../../assets/images/aiicon.png'
import dicon from '../../assets/images/dicon.png'
import Group15 from '../../assets/images/Group 15.png'
import xdicon from '../../assets/images/xdicon.png'
import htmlicon from '../../assets/images/htmlicon.png'
import angular from '../../assets/images/angular.png'
import cssicon from '../../assets/images/cssicon.png'
import shopify from '../../assets/images/shopify.png'
import appleicon from '../../assets/images/appleicon.png'
import reacticon from '../../assets/images/reacticon.png'
import javascript from '../../assets/images/javascript.png'
import teamsIcon from '../../assets/images/teams.png'; // or wherever your icon is


// crousel images
import Ediary from '../../assets/images/c.png'
import verka from '../../assets/images/amp.png'
import pbpolice from '../../assets/images/ang.png'
import brahmakumaris from '../../assets/images/bootstap.png'
import evyapari from '../../assets/images/docker.png'
import vidhyashree from '../../assets/images/ios.png'
import jukedock from '../../assets/images/js.png'
import wonderautomation from '../../assets/images/lv.png'
import fedex from '../../assets/images/mongodb.png'
import erealto from '../../assets/images/mysql.jpg'
import TheTimesGroup from '../../assets/images/react.png'
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

//about-us section image
import aboutus from '../../assets/images/about-us-image.png'


//founder 
import skype from '../../assets/images/Skype.svg'

import { NavLink, useNavigate } from 'react-router-dom'
import axios from 'axios'
function Banner() {
  const ImageLink = 'https://smarto.s3.ap-south-1.amazonaws.com/mindcode/client'
  const [crousalData, setCrousalData] = useState([])


  

  const getClient = async () => {
    await axios.get(`https://mindcoadmin.v4masters.com/public/index.php/getcrousalclient`,)
      .then((response) => {
        console.log('user', response.data)
        setCrousalData(response.data)
      }).catch((error) => {
      })
  }
  useEffect(() => {
    getClient()

  }, [])
  const navigate = useNavigate();

  const handleContactClick = () => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  };

  
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };
  return (
    <>
      {console.log(crousalData)}
      
      <section id="main-banner">
        <div className="banner-section-inner container">
          <div className="header-grid d-flex">
            <div className="left-side text-white">
              <h1 className="fw-medium">MINDCODE</h1>
              <h3 className="">A start up road & the Enterprises abode !</h3>
              <p className="fw-medium">
                Let's turn your brand into a successfull buisness
              </p>

              <div className="d-flex">
                <NavLink to={"tel:+91 9896570012"} onClick={handleContactClick} className="btn  btn-prp text-white">
                  Quick Call
                </NavLink>
               
              </div>
            </div>
            <div className="solar-system mb-4 mt-5 mb-lg-0">
              <div id="sun"></div>

              <div className="orbit mercury-orbit"></div>
              <div className="mercury-spin">
                <div id="mercury" className="d-flex">
                  <img src={psicon} alt="" height="40" />
                </div>
                <div id="mercury" className="mercury2 d-flex">
                  <img src={aiicon} alt="" height="40" />
                </div>
              </div>

              <div className="orbit venus-orbit"></div>
              <div className="venus-spin">
                <div id="venus" className="d-flex bg-white">
                  <img src={dicon} alt="" height="40" />
                </div>
                <div id="venus" className="venus2 d-flex">
                  <img src={Group15} alt="" height="40" />
                </div>
                <div id="venus" className="venus3 d-flex">
                  <img src={xdicon} alt="" height="40" />
                </div>
              </div>

              <div className="orbit earth-orbit"></div>
              <div className="earth-spin">
                <div id="earth" className="d-flex bg-white">
                  <img src={htmlicon} alt="" height="40" />
                </div>
                <div
                  id="earth"
                  className="earth2 d-flex align-items-center bg-white justify-content-center"
                >
                  <img src={angular} alt="" height="40" />
                </div>
                <div
                  id="earth"
                  className="earth3 d-flex align-items-center bg-white justify-content-center"
                >
                  <img src={cssicon} alt="" height="40" />
                </div>
              </div>
              <div className="orbit mars-orbit"></div>
              <div className="mars-spin">
                <div id="mars" className="d-flex bg-white">
                  <img src={shopify} alt="" height="40" />
                </div>
                <div id="mars" className="mars3 bg-white d-flex">
                  <img src={appleicon} alt="" />
                </div>
                <div id="mars" className="mars2 bg-white d-flex">
                  <img src={reacticon} alt="" />
                </div>
                <div id="mars" className="mars4 bg-white d-flex">
                  <img src={javascript} alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="section1" id="crousal-section">
        <div className="crousal-inner d-flex">
          <div className="ourclient-head">
            <h3 className="fw-semi-bold">Technology  we used</h3>

          </div>
          <div className=" crousal-side2">
            <OwlCarousel className="owl-one" items={7}
              loop
              dots={false}
              autoplay={true}
              autoplaySpeed={3000}
              autoplayTimeout={3000}

              margin={8}
              responsive={{
                0: {
                  items: 3
                },
                600: {
                  items: 5
                },
                1000: {
                  items: 7
                }
              }}>
          <a href="https://www.ediary.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={Ediary} alt="Ediary" /></div></div>
</a>
<a href="https://www.verka.coop" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={verka} alt="Verka" /></div></div>
</a>
<a href="https://www.punjabpolice.gov.in" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={pbpolice} alt="Punjab Police" /></div></div>
</a>
<a href="https://www.brahmakumaris.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={brahmakumaris} alt="Brahma Kumaris" /></div></div>
</a>
<a href="https://www.evyapari.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={evyapari} alt="E-Vyapari" /></div></div>
</a>
<a href="https://www.jukedock.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={jukedock} alt="JukeDock" /></div></div>
</a>
<a href="https://www.vidhyashree.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={vidhyashree} alt="Vidhyashree" /></div></div>
</a>
<a href="https://www.wonderautomation.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={wonderautomation} alt="Wonder Automation" /></div></div>
</a>
<a href="https://www.fedex.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={fedex} alt="FedEx" /></div></div>
</a>
<a href="https://www.erealto.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={erealto} alt="Erealto" /></div></div>
</a>
<a href="https://www.timesgroup.com" target="_blank" rel="noopener noreferrer">
  <div className="item"><div className="inner-item"><img src={TheTimesGroup} alt="The Times Group" /></div></div>
</a>

              {/* <div className="item "><div className="inner-item"><img src={Group57} alt="" /></div></div> */}
            </OwlCarousel>
            
          </div>
        </div>
      </section>

      <Ourservice />

      <section className="section3 bg-white" id="about-us">
        <div className="about-us-inner container">
          <div className="d-flex">
            <div className="left">
              <h2 className="text-purple fw-semi-bold">About us</h2>
              <p className="fw-medium">
                Ever wondered how we ensure success for both MindCodeLab and our
                clients?
              </p>
              <div className="text-gray">
                At Mind CodeLab, we believe in Vasudev Kutumbkam, where the whole
                world is our family. Dive into our story as we serve our global
                family with creativity and transparency. With a decade of
                expertise in Designing, Developing, Marketing, and Branding,
                Mind Code Lab Pvt Ltd has witnessed phenomenal growth since
                2013.
              </div>
              <div className="d-flex">
                <NavLink to={'/about'} onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })} className="btn btn-black text-white">
                  Read More
                </NavLink>
              </div>
            </div>
            <div className="right">
              <img src={aboutus} alt="" />
              <div className="experience">
                <h3 className="fw-semi-bold ten">11 +</h3>
                <h4 className="fw-semi-bold">Experience</h4>
              </div>
            </div>
          </div>
        </div>
      </section>


    <section className="section2 section4" id="our-feature">
  <div className="our-quality-section container text-white">
    <h2 className="fw-semi-bold">We are Featured in ....</h2>
    <div className="text-white">
      At Mind Code, With a decade of expertise in Designing, Developing,
      Marketing, and Branding, <br />
      Mind Code Lab Pvt Ltd has witnessed phenomenal growth since 2013.
    </div>

    {Array.isArray(crousalData) && crousalData.length > 0 ? (
      <OwlCarousel
        items={1}
        loop
        dots={false}
        autoplay
        autoplaySpeed={3000}
        nav
        navText={[
          '<i class="fa-solid fa-chevron-left"></i>',
          '<i class="fa-solid fa-chevron-right"></i>',
        ]}
        speed={500}
        margin={8}
        className="owl-two owl-carousel owl-theme"
        id="crousal2"
      >
        {crousalData.map((item) => (
          <div className="item" key={item.id || item.client_logo}>
            <div className="item1 image-section">
              <div className="inner-image">
                {item.link ? (
                  <a
                    href={item.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src={`${ImageLink}/${item.client_logo}`}
                      alt={item.client_name}
                    />
                  </a>
                ) : (
                  <img
                    src={`${ImageLink}/${item.client_logo}`}
                    alt={item.client_name}
                  />
                )}
              </div>
            </div>
          </div>
        ))}
      </OwlCarousel>
    ) : null}
  </div>
</section>


      <Contactus />


      <section className="section2 section6" id="our-founder">
        <div className="founder-section container d-flex">
          <h2 className="text-white fw-semi-bold">About CEO</h2>
          <div className="text-white">
            At MindCode, we believe in Vasudev Kutumbkam, where the whole world
            is our family. Dive <br />
            into our story as we serve our global family with creativity and
            transparency.
          </div>
          <div className="about-ceo">
            <div className="image-section"></div>
            <div className="text-section bg-white">
              <div>
                <h4 className="fw-bold">Kapil Partap</h4>
                <h6 className="fw-medium">CEO & Founder</h6>
              </div>
              <div>
                <h5 className="fw-bold">
                  Ready to take your Business to <br /> the Next Level?
                </h5>
                <h6 className="text-gray fw-medium">
                  Let’s scale it with custom software.
                </h6>
              </div>
              <span className="d-flex">
                <a href="https://teams.microsoft.com/l/chat/0/0?users=kapilpartap@example.com" ><img src={teamsIcon}/>
</a>

                <div>
                  <div className="discuss-about text-gray">
                    Discuss about project!
                  </div>
                  <span className="fw-medium">Let’s Connect</span>
                </div>
              </span>
            </div>
          </div>
        </div>
      </section>


    </>
  )
}

export default Banner;